export const CUSTOM_MODAL_STYLES = {
  content : {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    padding: '0px',
    overflow: 'none'
  }
}